import requestAction from '../../utils/requestAction'

//export const downloadComplaintMessageFile = (complaintId: number, complaintMessageId?: number, handleResponse?: (fileName: string, file: any) => void) =>
export const downloadComplaintMessageFile = (complaintId: number, fileId?: string, complaintMessageId?: number, handleResponse?: (file: any) => void) =>
  requestAction('COMPLAINT_MESSAGE_DOWNLOADFILE')(
    `complaints/message/download?complaintId=${complaintId}${complaintMessageId ? '&complaintMessageId=' + complaintMessageId : ''}${fileId ? '&fileId=' + fileId : ''}`,
    'GET',
    undefined,
    {
      'Accept': 'application/pdf',
      'Content-Type': 'application/pdf',
    },
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) }) // handleResponse(response.fileName, response.file) })

